import { useMemo } from "react";
import PropTypes from "prop-types";

import { alignItems } from "../../consts";
import { changeHistoryUtils } from "../../utils";

import WrapperContainer from "../Containers/WrapperContainer";
import FlexContainers from "../Containers/FlexContainers";
import { Paragraph2 } from "../Text/Paragraphs";
import { AuthorInfo, DateInfo, LogTable, LogTableWrapper } from "./styled";

const LogHistoryTable = ({
  logs,
  parseLogs = (logs) => logs,
  getLogAction = (logItem) => logItem
}) => {
  const parsedLogs = useMemo(() => {
    return parseLogs(logs);
  }, [logs]);

  return (
    <LogTableWrapper>
      <LogTable>
        <tbody>
          {parsedLogs?.map((logItem) => {
            return (
              <tr key={logItem.id}>
                <td>
                  <WrapperContainer
                    Container={FlexContainers.FlexColumnStart}
                    alignItems={alignItems.start}>
                    <AuthorInfo>{logItem.author}</AuthorInfo>

                    <DateInfo>
                      {changeHistoryUtils.formatDateFromTimestamp(logItem.timestamp)}
                    </DateInfo>
                  </WrapperContainer>
                </td>
                <td>
                  <Paragraph2>{getLogAction(logItem)}</Paragraph2>
                </td>
              </tr>
            );
          })}
        </tbody>
      </LogTable>
    </LogTableWrapper>
  );
};

LogHistoryTable.propTypes = {
  logs: PropTypes.arrayOf(PropTypes.object.isRequired),
  parseLogs: PropTypes.func.isRequired,
  getLogAction: PropTypes.func.isRequired
};

export default LogHistoryTable;
